module.exports = __webpack_public_path__ + "static/media/andymosmans.1a1780a0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/andymosmans.webp
// module id = 668
// module chunks = 0